export default __webpack_public_path__ + "static/media/answer_box_correct.edc97071.png";